"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../utils");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A LoginCard component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A LoginCard
 */
function LoginCard(props) {
  if (!props.rendering.fields) {
    return null;
  }
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var CTA = props => {
    var {
      linkUrl,
      linkTarget,
      linkAlt
    } = (0, _linkFieldSrc.linkFieldSrc)(props.CtaLink);
    return /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
      buttonType: props.CtaButtonType,
      label: props.CtaText,
      href: linkUrl,
      target: linkTarget,
      title: linkAlt,
      dataId: props.ctaDataId
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: 'basic'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Title, null, extractedFields.LoginCardTitle.value), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-card-cta mm-spacing"
  }, /*#__PURE__*/_react.default.createElement(CTA, {
    CtaButtonType: extractedFields.CtaButtonType1.value,
    CtaText: extractedFields.CtaText1.value,
    CtaLink: extractedFields.CtaLink1.value,
    ctaDataId: 'login-cta1'
  })), !(0, _lodash.isEmpty)(extractedFields.Label2.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, extractedFields.Label2.value), !(0, _lodash.isEmpty)(extractedFields.CtaText2.value) && /*#__PURE__*/_react.default.createElement("div", {
    className: "login-card-cta mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(CTA, {
    CtaButtonType: extractedFields.CtaButtonType2.value,
    CtaText: extractedFields.CtaText2.value,
    CtaLink: extractedFields.CtaLink2.value,
    ctaDataId: 'login-cta2'
  })), !(0, _lodash.isEmpty)(extractedFields.Label3.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, extractedFields.Label3.value), !(0, _lodash.isEmpty)(extractedFields.CtaText3.value) && /*#__PURE__*/_react.default.createElement("div", {
    className: "login-card-cta"
  }, /*#__PURE__*/_react.default.createElement(CTA, {
    CtaButtonType: extractedFields.CtaButtonType3.value,
    CtaText: extractedFields.CtaText3.value,
    CtaLink: extractedFields.CtaLink3.value,
    ctaDataId: 'login-cta3'
  })))));
}
var _default = exports.default = LoginCard;